import { useContext } from 'react';
import SelectedStoreContext from '../context/selectedStoreContext';

/**
 * useSelectedStoreContext is a convenience hook to access the auth context
 */
export default function useSelectedStoreContext() {
  return useContext(SelectedStoreContext);
}
